module.exports = __webpack_public_path__ + "static/img/logo4.63f61fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo4.jpg
// module id = TKat
// module chunks = 2